<template>
    <!-- ------------------------------------- 博客 ----------------------------------- -->
    <div class="blog" v-loading="loading" style="position: relative">
        <div id="mask" v-show="mask" @click="openmask()">
            <div class="scanText" style="text-align: center; width: 100%">
                扫描二维码分享
            </div>
            <div id="qrcode" ref="qrcode" v-show="mask == true"></div>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 标题 ---------------------------------- -->
        <div class="blog_title">
            <p>蔚诺快讯</p>
        </div>
        <!-- ---------------------------------- 文章 ---------------------------------- -->
        <div class="article">
            <!-- 主文章 -->
            <div class="article_main">
                <!-- 文章标题 -->
                <p class="article_title">{{ blog.title }}</p>
                <!-- 文章信息 -->
                <div class="article_information">
                    <!-- 日期时间 -->
                    <p class="article_time">{{ blog.releaseTime }}</p>
                    <!-- 第三方分享 -->
                    <div class="article_share">
                        <!-- <el-popover placement="top-start" trigger="hover">
              <div>
                <img
                  class="wechat_code"
                  src="../assets/images/icon/wechat-code.jpg"
                  alt=""
                />
              </div>
              <img
                src="../assets/images/icon/share1.png"
                alt=""
                slot="reference"
              />
            </el-popover> -->
                        <div style="display: flex">
                            <img
                                src="../assets/images/icon/share1.png"
                                alt=""
                                id="share-weixin"
                                @click="share_click('url')"
                            />
                        </div>
                        <img
                            src="../assets/images/icon/share2.png"
                            alt=""
                            @click="weibo(blog.title)"
                        />
                        <!-- <img src="../assets/images/icon/share3.png" alt="" @click="xhs"/> -->
                    </div>
                </div>
                <!-- 文章图片 -->
                <el-image
                style="    width: 100%;
    object-fit: contain;"   
                    :src="
                        'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                        blog.img
                    "
                ></el-image>
                <!-- <el-image
          v-lazy="
            'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' + blog.img
          "
        >

          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image> -->
                <!-- 文章标签 -->
                <p class="article_label">#{{ blog.label }}</p>
                <!-- 文章内容 -->
                <div class="article_brief" v-html="blog.content"></div>
                <!--                &lt;!&ndash; 评论统计 &ndash;&gt;-->
                <!--                <p class="num">{{commentList.length}}条留言</p>-->
                <!-- 输入栏 -->
                <div class="leave">留言</div>
                <div class="input_box">
                    <div class="input_content">
                        <el-input
                            class="textarea_input"
                            type="textarea"
                            :rows="4"
                            placeholder=""
                            v-model="submitBlog.input_box"
                        ></el-input>
                        <div class="name-liu">
                            <div>姓名 :</div>
                            <el-input
                                placeholder=""
                                v-model="submitBlog.name"
                            ></el-input>
                        </div>
                        <div class="name-liu">
                            <div>邮箱 :</div>
                            <el-input
                                placeholder=""
                                v-model="submitBlog.email"
                            ></el-input>
                        </div>
                    </div>
                    <div class="checked_style">
                        <!-- <el-checkbox v-model="submitBlog.subscribe" @click="subscribeClick"  @change="clickChange"  -->
                        <el-checkbox
                            v-model="submitBlog.subscribe"
                            @click="subscribeClick"
                            >同意订阅
                        </el-checkbox>
                        <el-button class="setup_button" @click="publish"
                            >提交
                        </el-button>
                    </div>
                    <!--                    <div style="margin-top: 10px;">-->
                    <!--                        <el-checkbox v-model="submitBlog.notice" @click="noticeClick">同意邮箱接收新回复通知</el-checkbox>-->
                    <!--                    </div>-->
                </div>
                <!-- 空评论 -->
                <div class="no-pl" v-if="commentList == ''">
                    <img
                        src="../assets/images/no-pl.png"
                        alt=""
                        class="no-pl-img"
                    />
                    <div class="pl-title">评论还是空空的，快来说两句吧~</div>
                </div>
                <!-- 评论内容 -->
                <div
                    class="comments"
                    v-for="(item, index) in commentList"
                    :key="index + '1'"
                >
                    <div style="display: flex; align-items: center">
                        <img class="user_pic" v-lazy="item.backup3" alt="" />
                        <div class="user_main">
                            <p class="user_name">{{ item.name }}</p>
                            <p>{{ item.commentContent }}</p>
                            <p class="like">
                                <span>赞</span>
                                <img
                                    @click="dianZan(index)"
                                    src="../assets/images/icon/heart.png"
                                    alt=""
                                    style="margin: 0 3px"
                                />
                                <b>{{ item.greatNum }}</b>
                                <span style="margin-left: 6%" class="huifu2">
                                    <span @click="openreply(index)">回复</span>
                                    <img
                                        src="../assets/images/blog-pl.png"
                                        alt=""
                                        style="margin: 0 3px"
                                        class="pinglun"
                                        @click="openreply(index)"
                                    />
                                </span>
                            </p>
                        </div>

                        <div class="user-time-all">
                            <div class="user_time">
                                {{
                                    item.commentTime.toString().substr(5, 1) ===
                                    '0'
                                        ? item.commentTime
                                              .toString()
                                              .substr(6, 1)
                                        : item.commentTime
                                              .toString()
                                              .substr(5, 2)
                                }}月{{
                                    item.commentTime.toString().substr(8, 2)
                                }}日
                            </div>
                            <div class="user-data">
                                {{ item.commentTime.toString().substr(11, 5) }}
                            </div>
                        </div>
                    </div>
                    <!-- 回复样式 -->
                    <div style="margin-top: 1%">
                        <div
                            class="huifu"
                            v-for="(item2, index2) in commentList[index].reply"
                            :key="index2"
                            v-show="true"
                        >
                            <div class="huifu1">
                                <div class="huifu-left">
                                    <img
                                        v-lazy="item2.backup1"
                                        alt=""
                                        style="width: 40px; height: 40px"
                                    />
                                    <div class="blog-name">
                                        <div class="huifu-title">
                                            {{ item2.replyContent }}
                                        </div>
                                    </div>
                                </div>
                                <div class="huifu-right">
                                    <div>
                                        {{
                                            item2.replyTime
                                                .toString()
                                                .substr(5, 1) === '0'
                                                ? item2.replyTime
                                                      .toString()
                                                      .substr(6, 1)
                                                : item2.replyTime
                                                      .toString()
                                                      .substr(5, 2)
                                        }}月{{
                                            item2.replyTime
                                                .toString()
                                                .substr(8, 2)
                                        }}日&nbsp;
                                    </div>
                                    <div>
                                        {{
                                            item2.replyTime
                                                .toString()
                                                .substr(11, 5)
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div
                                class="view_more"
                                @click="queryReply(index)"
                                v-if="
                                    (item.backup1 >= 3) &
                                    (index2 ===
                                        commentList[index].reply.length - 1)
                                "
                            >
                                查看更多回复
                            </div>
                        </div>
                    </div>
                    <div
                        v-show="item.backup2"
                        style="display: none; margin-bottom: 2%"
                        class="open"
                    >
                        <div class="name-huifu">
                            <el-input
                                type="textarea"
                                style="width: 100%"
                                placeholder=""
                                v-model="msgText"
                            ></el-input>
                            <div></div>
                            <div
                                class="send-txt"
                                style="
                                    color: #49b8e8;
                                    font-weight: 600;
                                    font-size: 18px;
                                "
                                @click="send(index)"
                            >
                                发送
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 查看更多留言 -->
                <div class="view_more" @click="queryPage" v-if="count >= 5">
                    查看更多留言
                </div>
            </div>
            <!-- 副文章 -->
            <div class="article_vice">
                <!-- 订阅我们 -->
                <img
                    class="subscribe"
                          src="../assets/images/subsc.png"
                    alt=""
                    @click="openSubscribe"
                />
                <!-- 图标组 -->
                <div class="icon_group">
                    <a
                        href="https://www.facebook.com/Renaud-Air-China-2139475802801534/"
                        target="_blank"
                    >
                        <img src="../assets/images/icon/facebook.png" alt="" />
                    </a>

                    <a href="instagram.com/renaudairchina" target="_blank">
                        <img src="../assets/images/icon/camera.png" alt="" />
                    </a>
                    <el-popover placement="top-start" trigger="hover">
                        <div>
                            <img
                                class="wechat_code"
                                src="../assets/images/icon/wechat-code.jpg"
                                alt=""
                            />
                        </div>
                        <img
                            slot="reference"
                            src="../assets/images/icon/wechat.png"
                            alt=""
                        />
                    </el-popover>
                    <a href="http://www.weibo.com/renaudair" target="_blank">
                        <img src="../assets/images/icon/sina.png" alt="" />
                    </a>
                    <a
                        href="https://www.xiaohongshu.com/user/profile/5ecf30ba0000000001003ddd?xhsshare=CopyLink&appuid=5ecf30ba0000000001003ddd&apptime=1626163317"
                        target="_blank"
                    >
                        <img src="../assets/images/icon/xhs.png" alt="" />
                    </a>
                </div>
                <el-row>
                    <el-col
                        v-for="(item, index) in blogsList"
                        :key="index"
                        v-if="(index + 1) % 2 == 0"
                    >
                        <!-- 虚线 -->
                        <div class="article_line" style="margin: 30px 0"></div>
                        <!-- 文章图片 -->
                        <!-- <el-image
              v-lazy="
                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                item.img
              "
            >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image> 
            <el-image
              :src="
                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                item.img
              "
            ></el-image>-->

                        <em
                            class="vice_pic"
                            v-if="item.img"
                            :style="{
                                backgroundImage: `url(${
                                    'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                    item.img
                                })`,
                            }"
                        ></em>
                        <!-- 标题 -->
                        <p class="vice_title">{{ item.title }}</p>
                        <!-- 日期时间 -->
                        <p class="vice_time">
                            {{ item.releaseTime.split(' ')[0] }}
                        </p>
                        <!-- 阅读更多 -->
                        <span class="vice_more" @click="toBlogDetails(item)"
                            >阅读更多 ></span
                        >
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- ---------------------------------- 分页栏 ---------------------------------- -->
        <!--        <div class="paging">-->
        <!--            <el-pagination background layout=" pager, next" :total="page.total" @current-change="currentChange($event)"></el-pagination>-->
        <!--        </div>-->
        <!-- ---------------------------------- 底部栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Axios from 'axios';
import QRCode from 'qrcodejs2';
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            mask: false,
            mask1: false,
            commentIdList: [],
            commentId: undefined,
            ping: false,
            opening: false,
            dVisible: false,
            greatNum: 0,
            msgText: '',
            pageNo: 1,
            replyPageNo: 1,
            count: 0,
            loading: false,
            blog: null,
            toollist: [],
            commentList: [],
            id: (() => {
                return this.$route.query.id;
            })(),
            blogsList: [],
            replyList: [],
            page: {
                pageNo: 1,
                pageSize: 10,
                total: 10,
            },
            submitBlog: {
                input_box: '',
                name: '',
                email: '',
                subscribe: false, // 同意订阅
                notice: false, // 同意接收新通知
            },
        };
    },
    created() {
        this.getbolgById();
        this.getCommentList();
        this.getBlogsList();
    },

    methods: {
        share_click(url) {
            document.getElementById('qrcode').innerHTML = ''; //在调用qrCode前使用js原生方法清空元素内容
            let qrcode = new QRCode('qrcode', {
                width: 200, //图像宽度
                height: 200,
                colorDark: '#000000', //前景色
                colorLight: '#ffffff', //背景色
                typeNumber: 4,
                correctLevel: QRCode.CorrectLevel.H, //
            });

            var url = location.href;
            qrcode.clear(); //清除二维码
            qrcode.makeCode(url); //生成另一个新的二维码
            // var mask = document.getElementById('mask')
            this.mask = !this.mask;
        },
        openmask() {
            this.mask = !this.mask;
        },

        //点赞
        dianZan(index) {
            let url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/commentEdit`;
            let data = {
                id: this.commentList[index].id,
                greatNum: Number(this.commentList[index].greatNum) + 1,
            };
            let item = localStorage.getItem('commentIdList');
            if (item !== null) {
                if (item.indexOf(this.commentList[index].id) === -1) {
                    Axios.put(url, data).then((res) => {
                        if (res.data.success === true) {
                            this.commentIdList.push(this.commentList[index].id);
                            this.$message.info('点赞成功', 1);
                            localStorage.setItem(
                                'commentIdList',
                                JSON.stringify(this.commentIdList)
                            );
                            this.queryById(index);
                        } else {
                            this.$message.warning(res.data.message);
                        }
                    });
                } else {
                    this.$message.warning('请勿重复点赞！');
                }
            } else {
                Axios.put(url, data).then((res) => {
                    if (res.data.success === true) {
                        this.commentIdList.push(this.commentList[index].id);
                        this.$message.info('点赞成功', 1);
                        localStorage.setItem(
                            'commentIdList',
                            this.commentIdList
                        );
                        this.queryById(index);
                    } else {
                        this.$message.warning(res.data.message);
                    }
                });
            }
        },
        //根据commentId查询comment
        queryById(val) {
            var that = this;
            let url =
                `${this.api.ip}/jeecg-boot/h5/H5Controller2/queryById?id=` +
                that.commentList[val].id;
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    that.commentList[val].greatNum = res.data.result.greatNum;
                }
            });
        },
        // 跳转小红书
        xhs() {
            window.open(
                'https://www.xiaohongshu.com/user/profile/5ecf30ba0000000001003ddd?xhsshare=CopyLink&appuid=5ecf30ba0000000001003ddd&apptime=1626163317',
                '_blank'
            );
        },
        weibo(item) {
            window.open(
                'http://service.weibo.com/share/share.php?title=' +
                    item +
                    '&url=http://www.renaudchina.com/blog?id=' +
                    this.id,
                '_blank'
            );
            // window.open("https://www.weibo.com/renaudair", "_blank");
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        // 留言板
        send(index) {
            var that = this;
            if (that.msgText === '') {
                this.$message.warning('内容不能为空！', 1);
                return;
            }
            let url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/replyAdd`;
            let data = {
                commentId: that.commentList[index].id,
                replyContent: that.msgText,
            };
            Axios.post(url, data).then((res) => {
                if (res.data.success === true) {
                    //  that.commentList[index].reply.push(that.msgText);
                    that.msgText = '';
                    this.$message.info('回复成功！', 1);
                    that.commentList[index].backup2 = false;
                    this.getCommentList();
                }
            });
        },
        // 回复评论
        openreply(val) {
            for (let i = 0; i < this.commentList.length; i++) {
                if (i !== val) {
                    this.commentList[i].backup2 = false;
                }
            }
            this.commentList[val].backup2 = !this.commentList[val].backup2;
            let huifu = document.querySelector('.huifu2');
            // let huifu1 = document.querySelector('.huifu3')

            let open = document.querySelector('.open');
            huifu.onclick = function () {
                open.style.dispaly = 'block';
            };
            // huifu1.onclick = function () {
            //   open.style.dispaly = "block";
            // }
        },
        //点击同意订阅
        subscribeClick() {
            var that = this;
            that.submitBlog.subscribe = !that.submitBlog.subscribe;
        },
        clickChange(val) {
            var that = this;
        },
        //点击同意邮箱
        noticeClick() {
            var that = this;
        },
        /** 查看更多 **/
        queryPage() {
            var that = this;
            that.pageNo += 1;
            this.getCommentList(that.pageNo);
        },
        /** 进入订阅我们 **/
        openSubscribe() {
            // this.$router.push({
            //   path: "/subscribe",
            // });
            window.open('http://www.renaudchina.com/subscribe', '_blank');
        },
        /** 点击阅读更多 **/
        toBlogDetails(item) {
            this.$router.push({
                path: '/blogDetails',
                query: {
                    id: item.id,
                },
            });
            this.loading = true;
            location.reload();
        },
        /** 切换分页 **/
        currentChange(index) {
            this.page.pageNo = index;
            this.getBlogsList();
        },
        /** 获取列表 **/
        getBlogsList() {
            let page = JSON.parse(JSON.stringify(this.page));
            var url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/blogsList`;
            Axios.get(url, {
                params: {
                    pageNo: page.pageNo,
                    pageSize: page.pageSize,
                },
            }).then((res) => {
                if (res.data.code === 200) {
                    res.data.result.records.forEach((item) => {
                        if (item.releaseTime) {
                            let date = item.releaseTime
                                .substring(0, 19)
                                .replace(/-/g, '/');
                            let time =
                                new Date().getTime() - new Date(date).getTime();
                            var days = parseInt(time / 1000 / 60 / 60 / 24, 10); //计算剩余的天数
                            var hours = parseInt(
                                (time / 1000 / 60 / 60) % 24,
                                10
                            ); //计算剩余的小时
                            this.$set(
                                item,
                                'pastTimes',
                                `${days ? days + '天 / ' : ''}${hours}小时`
                            );
                        }
                    });
                    this.blogsList = res.data.result.records;

                    this.page.pageNo = res.data.result.pages;
                    this.page.pageSize = res.data.result.size;
                    this.page.total = res.data.result.total;

                }
            });
        },
        /** 发表 **/
        publish() {
            let reg = new RegExp(
                '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
            ); //正则表达式
            let adopt = false;
            if (this.submitBlog.email) {
                if (!reg.test(this.submitBlog.email)) {
                    adopt = false;
                } else {
                    adopt = true;
                }
            } else {
                adopt = true;
            }
            if (this.submitBlog.subscribe == true) {
                if (!this.submitBlog.input_box) {
                    this.$message.warning('评论内容不能为空', 1);
                    return;
                } else if (!this.submitBlog.name) {
                    this.$message.warning('姓名不能为空', 1);
                    return;
                } else if (!this.submitBlog.email) {
                    this.$message.warning('邮箱不能为空', 1);
                    return;
                } else if (!this.submitBlog.email && !adopt) {
                    this.$message.warning('请填写正确格式的邮箱！', 1);
                    return;
                }

                let url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/commentAdd`;
                Axios.post(url, {
                    name: this.submitBlog.name, //姓名 （必填）
                    email: this.submitBlog.email, //邮箱 （必填）
                    commentContent: this.submitBlog.input_box, //评论内容 （必填）
                    greatNum: 0, //点赞数
                    blogsId: this.id, //博客的id，从blog页面传进来的 （必传）
                    backup4: '1', //订阅
                }).then((res) => {
                    if (res.data.success === true) {
                        this.$message.info('提交成功！', 1);
                        this.submitBlog = {
                            input_box: '',
                            name: '',
                            email: '',
                            subscribe: false,
                            notice: false,
                        };
                        this.submitBlog.subscribe = false;
                    } else {
                        this.$message.warning(res.data.message);
                    }
                });
            }
            if (this.submitBlog.subscribe == false) {
                if (!this.submitBlog.input_box) {
                    this.$message.warning('评论内容不能为空！', 1);
                    return;
                }
                let url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/commentAdd`;
                Axios.post(url, {
                    name: this.submitBlog.name, //姓名 （非必填）
                    email: this.submitBlog.email, //邮箱 （非必填）
                    commentContent: this.submitBlog.input_box, //评论内容 （必填）
                    greatNum: 0, //点赞数
                    blogsId: this.id, //博客的id，从blog页面传进来的 （必传）
                    backup4: '0', //不订阅
                }).then((res) => {
                    if (res.data.success === true) {
                        this.$message.info('提交成功！', 1);
                        this.submitBlog = {
                            input_box: '',
                            name: '',
                            email: '',
                            subscribe: false,
                            notice: false,
                        };
                        this.submitBlog.subscribe = false;
                    }
                });
            }
        },
        /** 根据id查询博客 **/
        getbolgById() {
            let url =
                `${this.api.ip}/jeecg-boot/h5/H5Controller2/blogsListById?id=` +
                this.id;
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    /** 根据博客的id查出对应博客, that.commentList.count 是当前博客的评论条数 **/
                    this.blog = res.data.result;
                }
            });
        },
        /** 查询评论及回复 **/
        getCommentList(val) {
            var that = this;
            /** 这个请求的id需要从blog页面点击的时候传过来，点击哪个博客，根据这个id查询具体的评论及评论的回复数据 **/
            /** 根据博客的id查出所有的评论，每一个返回的评论参数里有一个属性reply是评论对应回复的数据（that.commentList[0].reply[0]）注:这就是第一个评论的第一个回复 **/
            let url = '';
            if (val != null) {
                url =
                    `${this.api.ip}/jeecg-boot/h5/H5Controller2/commentListById?blogsId=` +
                    this.id +
                    '&pageNo=' +
                    val;
            } else {
                url =
                    `${this.api.ip}/jeecg-boot/h5/H5Controller2/commentListById?blogsId=` +
                    this.id;
            }
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    that.commentList = [];
                    if (that.commentList.length > 0) {
                        for (let i = 0; i < res.data.result.length; i++) {
                            that.commentList.push(res.data.result[i]);
                            that.commentList[
                                that.commentList.length - 1
                            ].backup1 = (
                                that.commentList[that.commentList.length - 1]
                                    .reply === null
                                    ? 0
                                    : that.commentList[
                                          that.commentList.length - 1
                                      ].reply
                            ).length;
                            that.commentList[
                                that.commentList.length - 1
                            ].backup2 = false;
                            that.commentList[
                                that.commentList.length - 1
                            ].backup3 = require('../assets/images/tx-' +
                                (Math.floor(Math.random() * (13 - 1 + 1)) + 1) +
                                '.png');
                            that.commentList[
                                that.commentList.length - 1
                            ].backup5 = 1;
                            if (
                                that.commentList[that.commentList.length - 1]
                                    .reply !== null
                            ) {
                                for (
                                    let j = 0;
                                    j <
                                    that.commentList[
                                        that.commentList.length - 1
                                    ].reply.length;
                                    j++
                                ) {
                                    that.commentList[
                                        that.commentList.length - 1
                                    ].reply[
                                        j
                                    ].backup1 = require('../assets/images/tx-' +
                                        (Math.floor(
                                            Math.random() * (13 - 1 + 1)
                                        ) +
                                            1) +
                                        '.png');
                                }
                            }
                        }
                    } else {
                        that.commentList = res.data.result;
                        for (let i = 0; i < that.commentList.length; i++) {
                            that.commentList[i].backup1 = (
                                that.commentList[i].reply === null
                                    ? 0
                                    : that.commentList[i].reply
                            ).length;
                            that.commentList[i].backup2 = false;
                            that.commentList[
                                i
                            ].backup3 = require('../assets/images/tx-' +
                                (Math.floor(Math.random() * (13 - 1 + 1)) + 1) +
                                '.png');
                            that.commentList[i].backup5 = 1;
                            if (that.commentList[i].reply !== null) {
                                for (
                                    let j = 0;
                                    j < that.commentList[i].reply.length;
                                    j++
                                ) {
                                    that.commentList[i].reply[
                                        j
                                    ].backup1 = require('../assets/images/tx-' +
                                        (Math.floor(
                                            Math.random() * (13 - 1 + 1)
                                        ) +
                                            1) +
                                        '.png');
                                }
                            }
                        }
                    }
                    that.count = res.data.result.length;
                }
            });
        },
        //添加评论的回复
        replyAdd() {
            let url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/replyAdd`;
            Axios.post(url, {
                name: 'aaa', //姓名 （必填）
                email: 'aaa', //邮箱 （必填）
                replyContent: 'aaaa', //回复内容 （必填）
                commentId: 1, //评论id （必传）
            }).then((res) => {
                if (res.data.success === true) {
                    this.$message.info('评论成功', 1);
                }
            });
        },
        //查询评论回复
        queryReply(val) {
            var that = this;
            // if (that.commentId !== undefined){
            //   if (that.commentId === that.commentList[val].id){
            //     that.replyPageNo += 1
            //   }else {
            //     for (let i = 0; i < that.commentList.length; i++) {
            //       if (that.commentList[i].id === that.commentId){
            //         this.queryById2(i)
            //       }
            //     }
            //     that.commentId = that.commentList[val].id
            //     that.replyPageNo = 2
            //   }
            // }else {
            //   that.commentId = that.commentList[val].id
            //   that.replyPageNo += 1
            // }
            that.commentList[val].backup5 += 1;
            let url =
                `${this.api.ip}/jeecg-boot/h5/H5Controller2/replyListById?commentId=` +
                that.commentList[val].id +
                '&pageNo=' +
                that.commentList[val].backup5;
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    if (that.commentList[val].reply !== null) {
                        if (res.data.result.records !== null) {
                            for (
                                let i = 0;
                                i < res.data.result.records.length;
                                i++
                            ) {
                                that.commentList[val].reply.push(
                                    res.data.result.records[i]
                                );
                                if (that.commentList[val].reply !== null) {
                                    that.commentList[val].reply[
                                        that.commentList[val].reply.length - 1
                                    ].backup1 = require('../assets/images/tx-' +
                                        (Math.floor(
                                            Math.random() * (13 - 1 + 1)
                                        ) +
                                            1) +
                                        '.png');
                                }
                            }
                            that.commentList[val].backup1 =
                                res.data.result.records.length;
                        }
                    } else {
                        that.commentList[val].reply = res.data.result.records;
                        if (that.commentList[val].reply !== null) {
                            for (
                                let i = 0;
                                i < that.commentList[val].reply.length;
                                i++
                            ) {
                                that.commentList[val].reply[
                                    i
                                ].backup1 = require('../assets/images/tx-' +
                                    (Math.floor(Math.random() * (13 - 1 + 1)) +
                                        1) +
                                    '.png');
                            }
                        }
                        that.commentList[val].backup1 =
                            res.data.result.records.length;
                    }
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.wechat_code {
    width: 200px;
}

.image-slot {
    font-size: 20px;
}
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
}

// ---------------------------- 标题 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .blog_title {
        height: 172px;
        p {
            font-size: 76px;
            padding: 1% 0 0 0;
        }
    }
    .name-liu {
        border: 0.035208rem solid #dcdfe6 !important;
        div {
            width: 12%;
            text-align: center;
        }
    }
    .el-checkbox {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__inner {
            border: 0.035208rem solid #dcdfe6 !important;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .blog_title {
        height: 142px;
        p {
            font-size: 46px;
            // padding: 2% 0 0 0;
            line-height: 132px;
        }
    }
}
.blog_title {
    width: 100%;
    background: url('../assets/images/problem-bg.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    p {
        color: #ffffff;
        letter-spacing: 15px;
        font-family: '等线';
        text-align: center;
    }
}

// ---------------------------- 文章 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .article {
        width: 90%;
        // 主文章
        .article_main {
            width: 100%;
            // 文章标题
            .article_title {
                font-size: 70px;
            }
            // 文章信息
            .article_information {
                // 日期时间
                .article_time {
                    font-size: 44px;
                    margin-bottom: 30px;
                }
                // 第三方分享
                .article_share {
                    img {
                        width: 240px;
                        height: 100px;
                    }
                }
            }
            // 文章标签
            .article_label {
                font-size: 62px;
            }
            // 文章内容
            .article_brief {
                font-size: 52px !important;
                /deep/ span {
                    font-size: 60px !important;
                }
            }
        }
        // 留言
        .leave {
            font-size: 76px;
        }
        // 副文章
        .article_vice {
            display: none;
        }
        .textarea_input-liuyan {
            height: 100px;
        }
    }
    // 用户头像
    .user_pic {
        width: 207px;
        height: 207px;
    }
    // 用户昵称
    .user_name {
        font-size: 57px;
    }
    .user_main {
        p {
            font-size: 58px;
        }
    }
    // 赞
    .like {
        font-size: 36px;
    }
    .pinglun {
        width: 48px;
        height: 48px;
    }
    /deep/ .el-checkbox__inner {
        width: 58px;
        height: 58px;
    }
    /deep/ .el-checkbox__label {
        font-size: 57px;
        line-height: 57px;
    }
    // 提交按钮
    .setup_button {
        margin-top: 20px;
        width: 320px;
        margin-left: 5%;
        background: #164194;
        font-size: 58px;
        font-family: Microsoft YaHei;
        line-height: 1.5;
        border-radius: 10px;
        color: #fff;
    }
    .setup_button:hover {
        opacity: 0.8;
    }
    .checked_style {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 100px;
    }
    /deep/ .el-input {
        height: 100px;
    }
    /deep/ .el-input__inner {
        font-size: 48px;
    }
    .name-liu {
        font-size: 80px;
        div {
            font-size: 48px;
            padding-left: 30px;
        }
    }
    /deep/ .el-textarea__inner {
        font-size: 50px;
    }
    /deep/ .el-checkbox__inner::after {
        height: 40px;
        width: 20px;
        left: 15ápx;
    }
    .user-time-all {
        font-size: 60px !important;
    }
    .huifu-title {
        font-size: 60px !important;
    }
    .huifu-right {
        font-size: 60px !important;
    }
    .send-txt {
        width: 14% !important;
        font-size: 70px !important;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .article {
        width: 75%;
        // 主文章
        .article_main {
            width: 65%;
            // 文章标题
            .article_title {
                font-size: 50px;
            }
            // 文章信息
            .article_information {
                display: flex;
                align-items: center;
                justify-content: space-between;
                // 日期时间
                .article_time {
                    font-size: 22px;
                    margin: 0;
                }
                // 第三方分享
                .article_share {
                    img {
                        width: 90px;
                        height: 40px;
                    }
                }
            }
            // 文章标签
            .article_label {
                font-size: 22px;
            }
            // 文章内容
            .article_brief {
                font-size: 22px;
                /deep/ section{
                    /deep/ img{
                        width: 100%;
                        object-fit: contain;
                    }
                }
                /deep/ p{
                    /deep/ img{
                       width: 100%;
                        object-fit: contain; 
                    }
                }
            }
        }
        // 留言
        .leave {
            font-size: 20px;
        }
        // 副文章
        .article_vice {
            display: block;
        }
        .textarea_input-liuyan {
            height: 50px;
        }
    }
    // 用户头像
    .user_pic {
        width: 67px;
        height: 67px;
    }
    // 用户昵称
    .user_name {
        font-size: 17px;
    }
    .user_main {
        p {
            font-size: 17px;
        }
    }
    // 赞
    .like {
        font-size: 16px;
    }
    .pinglun {
        width: 18px;
        height: 18px;
    }
    /deep/ .el-checkbox__inner {
        width: 18px;
        height: 18px;
    }
    /deep/ .el-checkbox__label {
        font-size: 17px;
    }
    // 提交按钮
    .setup_button {
        margin-top: 20px;
        width: 120px;
        margin-left: 5%;
        background: #164194;
        font-size: 18px;
        font-family: Microsoft YaHei;
        display: block;
        color: #fff;
    }
    .setup_button:hover {
        opacity: 0.8;
    }
    .name-liu {
        div {
            font-size: 18px;
        }
    }
    /deep/ .el-checkbox__inner::after {
        height: 0.052083rem;
        left: 0.03125rem;
    }
}

.article {
    margin: 0 auto;
    padding: 80px 0 60px 0;
    display: flex;
    justify-content: space-between;
    font-family: '等线';
    // 主文章
    .article_main {
        // 文章标题
        .article_title {
            color: #164194;
            letter-spacing: 2px;
            margin: 0;
            cursor: pointer;
        }
        // 文章信息
        .article_information {
            width: 100%;
            margin: 10px 0 30px 0;
            // 日期时间
            .article_time {
                color: #164194;
                letter-spacing: 1px;
            }
            // 第三方分享
            .article_share {
                display: flex;
                img {
                    margin: 0 2px;
                    cursor: pointer;
                }
            }
        }
        // 文章图片
        .article_pic {
            width: 100%;
        }
        // 文章标签
        .article_label {
            margin: 20px 0;
            color: #49b8e8;
            letter-spacing: 2px;
        }
        // 文章内容
        .article_brief {
            width: 100%;
            color: #164194;
            line-height: 1.6;
            margin-bottom: 50px;
            box-sizing: border-box;
            overflow: hidden;
        }
        // 留言
        .leave {
            color: #164194;
            border-bottom: 1px solid #f2f2f2;
            font-family: Microsoft YaHei;
        }
        // 评论数
        .num {
            font-size: 22px;
            color: #164194;
        }
        // 输入栏
        .input_box {
            margin-top: 10px;
            width: 100%;
            .input_content {
                // font-weight: 600;
                color: #164194;
                overflow: hidden;
            }
            /deep/ .el-textarea__inner {
                border: 3px solid skyblue;
            }
            .checked_style {
                margin-top: 20px;
                // color: #164194;
                font-family: Microsoft YaHei;
            }

            /deep/ .el-checkbox__label {
                color: #164194;
                margin-bottom: 8px;
            }
            img {
                width: 67px;
                height: 67px;
            }
            /deep/ .el-input {
                // margin-top: 20px;
                width: 95%;
                float: right;
            }
            /*input {*/
            /*    width: 90%;*/
            /*    height: 65px;*/
            /*    border: 1px solid #164194;*/
            /*    font-size: 30px;*/
            /*    outline: none;*/
            /*    box-sizing: border-box;*/
            /*    padding-left: 10px;*/
            /*}*/
        }
        // 评论内容
        .comments {
            width: 100%;
            // display: flex;
            justify-content: space-between;
            margin: 30px 0;
            align-items: center;
            // 评论内容
            .user-time-all {
                font-size: 18px;
                width: 44%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding-right: 20px;
                .user-data {
                    margin-left: 3%;
                }
            }
            .user_main {
                width: 90%;
                margin-left: 2%;
                font-family: Microsoft YaHei;
                p {
                    color: #164194;
                    margin: 0;
                }
                .user_name {
                    margin-bottom: 2px;
                    span {
                        margin-left: 15px;
                    }
                }
                .like {
                    color: #49b8e8;
                    margin-top: 10px;
                    span {
                        cursor: pointer;
                        margin-left: 20px;
                        &:first-child {
                            margin-left: 0;
                        }
                    }
                    img {
                        cursor: pointer;
                        margin: 0 10px 0 5px;
                    }
                    .pinglun {
                        cursor: pointer;
                    }
                }
            }
        }
        // 查看更多内容
        .view_more {
            width: 100%;
            // margin-top: 40px;
            font-size: 17px;
            color: #164194;
            font-family: '等线';
            letter-spacing: 2px;
            text-align: center;
            line-height: 45px;
            background-color: #b0c4e6;
            cursor: pointer;
        }
    }
    // 副文章
    .article_vice {
        width: 30%;
        // 订阅我们
        .subscribe {
            width: 100%;
            cursor: pointer;
            display: block;
        }
        // 图标组
        .icon_group {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 22px 0;

            img {
                width: 52px;
                height: 52px;
            }
        }

        // 插图
        .vice_pic {
            width: 100%;
            display: inline-block;
            height: 120px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
        }
        // 标题
        .vice_title {
            font-size: 28px;
            color: #164194;
            letter-spacing: 2px;
            margin: 25px 0 10px 0;
            width: 83%;
        }
        // 日期时间
        .vice_time {
            font-size: 22px;
            color: #164194;
            letter-spacing: 1px;
            margin: 15px 0;
        }
        // 阅读更多
        .vice_more {
            font-size: 22px;
            color: #49b8e8;
            letter-spacing: 2px;
            cursor: pointer;
        }
    }
}
// 虚线
.article_line {
    width: 100%;
    border-bottom: 3px dashed #164194;
    margin: 60px 0;
}
// ---------------------------- 分页栏 ---------------------------------
.paging {
    width: 65%;
    margin: 0 auto;
    margin-bottom: 100px;
}
.paging /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #575756;
}
.paging /deep/ .el-pager li {
    width: 51px;
    height: 51px;
    border: 1px solid #575756;
    font-size: 26px;
    font-weight: lighter;
    line-height: 51px;
}
.paging /deep/ .el-pagination .btn-next {
    width: 51px;
    height: 51px;
    background-color: #fff;
}
.paging /deep/ .el-pagination .btn-prev {
    width: 51px;
    height: 51px;
    background-color: #fff;
}
.paging /deep/ .el-pagination .btn-next .el-icon {
    font-size: 28px;
}
.paging /deep/ .el-pagination .btn-prev .el-icon {
    font-size: 28px;
}
// 没有评论
.no-pl {
    width: 100%;
    text-align: center;
    margin-top: 10%;
}
.no-pl-img {
    width: 70px;
    height: 70px;
    opacity: 0.3;
}
.pl-title {
    font-size: 20px;
    margin-top: 10px;
}
.huifu {
    width: 100%;
    margin: auto;
    // display: flex;
    justify-content: space-between;
    background: #f3f3f3;
    box-sizing: border-box;
    padding: 0 20px 0 40px;
    // height: 10%;
    // margin-bottom: 3%;
    .huifu1 {
        width: 100%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        padding: 10px 0 10px 0;
        border-bottom: 1px solid rgb(224, 221, 221);
        box-sizing: border-box;
    }
    .huifu-left {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 35px;
        .blog-name {
            width: 100%;
            margin-left: 2%;
            font-size: 17px;
        }
        .huifu-title {
            padding-top: 2px;
            // color: #000;
            font-size: 18px;
            color: #164194;
            font-family: Microsoft YaHei;
        }
    }
    .huifu-right {
        // width: 20%;
        display: flex;
        font-size: 18px;
        // color: #49b8e8;
        align-items: center;
    }
}
/deep/ .el-input__inner {
    border: 0;
    padding: 0;
}
.name-huifu {
    display: flex;
    margin-top: 10px;
    align-items: center;
    border: 0.005208rem solid #dcdfe6;
    border-radius: 5px;
    /deep/ .el-textarea__inner {
        border: 0;
    }
    div {
        width: 10%;
        font-size: 18px;
        text-align: center;
    }
}
.name-liu {
    display: flex;
    align-items: center;
    border: 0.015208rem solid #dcdfe6;
    border-radius: 5px;
    width: 100%;
    font-family: Microsoft YaHei;
    margin: 20px 0;
    div {
        width: 12%;
        text-align: center;
    }
}

//  #qrcode{
//   position: absolute;
//   top: 52%;
//   // left: 40%;
//   right: 0;
//   z-index: 14;

// }

//   #mask {
//   position: absolute;
//   opacity: 0.9;
//   //  filter:alpha(opacity=50);
//   bottom: 0;
//   // left: 38%;
//   right: 0;
//   top: 30%;
//   background: #fff;
//   z-index: 13;
//   border-radius: 15px;
//   //  display: none;
// }

@media screen and (max-height: 3050px) {
    #qrcode {
        // position: absolute;
        // top: 26%;
        // left: 32%;
        /* right: 0; */
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 10px;
    }
    #qrcode img {
        width: 200px; //图像宽度
        height: 200px; //图像高度
        // position: absolute;
        // top: 32px;
    }

    #mask {
        position: fixed;
        opacity: 0.9;
        //  filter:alpha(opacity=50);
        left: 50%;
        top: 50%;
        padding: 40px;
        transform: translate(-50%, -50%);
        background: #fff;
        z-index: 13;
        border-radius: 15px;
        //  display: none;
    }
    .scanText {
        font-size: 20px;
    }
}
// @media screen and (max-height: 920px) {
//    #qrcode{
//    position: absolute;
//     top: 26%;
//     left: 28%;
//     /* right: 0; */
//     z-index: 14;
//   }

//   #qrcode img{
//       width:220px;//图像宽度
//      height: 220px; //图像高度
//      position: absolute;
//      top: 32px;
//   }

//   #mask {
//   position: absolute;
//   opacity: 0.9;
//   //  filter:alpha(opacity=50);
//   bottom: 0;
//   left: 38%;
//   right: 0;
//   top: 7%;
//   width:500px;
//   height: 450px;
//   background: #fff;
//   z-index: 13;
//   border-radius: 15px;
//   //  display: none;
// }
// }

/deep/ .el-image__error {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/blogDetails.vue